module.exports = __webpack_public_path__ + "img/㴩阁寻梅.e3cc337c.jpg";